export function LockFat({ ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="currentColor"
      {...props}
    >
      <g id="Icon" transform="translate(-785 -395)">
        <rect
          id="Rectangle_6402"
          data-name="Rectangle 6402"
          width="24"
          height="24"
          transform="translate(785 395)"
          fill="none"
        />
        <path
          id="Path_50064"
          data-name="Path 50064"
          d="M2893.75,3728.778v-2.167a3.753,3.753,0,0,0-7.5,0v2.167m1.35,7.222h4.8a5.732,5.732,0,0,0,2.37-.238,2.111,2.111,0,0,0,.982-.946,5.142,5.142,0,0,0,.248-2.282v-.289a5.141,5.141,0,0,0-.248-2.282,2.11,2.11,0,0,0-.982-.946,5.726,5.726,0,0,0-2.37-.239h-4.8a5.726,5.726,0,0,0-2.37.239,2.11,2.11,0,0,0-.982.946,5.141,5.141,0,0,0-.248,2.282v.289a5.142,5.142,0,0,0,.248,2.282,2.111,2.111,0,0,0,.982.946A5.732,5.732,0,0,0,2887.6,3736Z"
          transform="translate(-2093 -3323)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
}
